import React from 'react';
import {withTranslation} from "react-i18next";

let RewardAccountLimitReachedComponent = ({t}) => {



	return <div  className="claim-options-error row">
		<div className="col-2"><span className="exclamation-sign"></span></div>
		<div className="col-10">{t('reward.claim.options.accountlimitreached')}</div>
	</div>;
};

export default withTranslation() (RewardAccountLimitReachedComponent)